var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52839 9.46944V8.74224H10.2253C10.6033 8.74224 10.89 8.66754 11.0851 8.51814C11.2802 8.36874 11.3778 8.15374 11.3778 7.87324V7.86404C11.3778 7.58354 11.2757 7.37314 11.0714 7.23294C10.8701 7.08964 10.5729 7.01794 10.1795 7.01794H8.52839V6.34564H10.0194C10.3823 6.34564 10.6582 6.28004 10.8473 6.14894C11.0394 6.01484 11.1354 5.82274 11.1354 5.57264V5.56354C11.1354 5.31964 11.0485 5.12904 10.8747 4.99184C10.704 4.85464 10.4616 4.78604 10.1475 4.78604H8.52839V4.05884H10.3899C10.9326 4.05884 11.3565 4.17924 11.6614 4.42014C11.9693 4.66104 12.1233 4.98874 12.1233 5.40344V5.41264C12.1233 5.69614 12.0257 5.94924 11.8306 6.17184C11.6355 6.39134 11.3946 6.52404 11.108 6.56974V6.63374C11.3641 6.65814 11.5882 6.72834 11.7803 6.84414C11.9754 6.96004 12.1264 7.11244 12.2331 7.30154C12.3429 7.48754 12.3977 7.69794 12.3977 7.93264V7.93724C12.3977 8.25134 12.3185 8.52424 12.1599 8.75594C12.0044 8.98464 11.7818 9.16144 11.4922 9.28644C11.2025 9.40844 10.8549 9.46944 10.4494 9.46944H8.52839ZM8.03448 9.46944V4.05884H9.02699V9.46944H8.03448ZM12.97 9.46944V4.05884H16.6335V4.84544H13.9625V6.34564H16.4871V7.09574H13.9625V8.68274H16.6335V9.46944H12.97ZM18.7562 9.46944V4.84544H16.9999V4.05884H21.5095V4.84544H19.7532V9.46944H18.7562Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0915 1.06445H7.10459C3.74205 1.06445 1.01617 3.79032 1.01617 7.15285C1.01617 10.5154 3.74205 13.2413 7.10459 13.2413H22.0915C25.454 13.2413 28.1799 10.5154 28.1799 7.15285C28.1799 3.79032 25.454 1.06445 22.0915 1.06445Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.93668
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBet);
export default __webpack_public_path__ + "static/media/bet.977220c6330dc535238a25c84a9eeb0c.svg";
export { ForwardRef as ReactComponent };